import React, { ReactElement, ReactNode, useCallback, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../../common/constants/routes';
import { useSearchParams } from 'react-router-dom';
import { fetchCompanies, selectAllCompanies } from '../../../../slices/companies/companiesSlice';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useAppSelector } from '../../../../common/hooks/useAppSelector';
import { useAuth } from '@clerk/clerk-react';
import { useAppDispatch } from '../../../../common/hooks/useAppDispatch';

export const NoCompanyHandler = ({
  children,
}: {
  children?: ReactNode | undefined;
}): ReactElement => {
  const { isSignedIn } = useAuth();
  const [searchParams] = useSearchParams();
  const backUrl = searchParams.get('backUrl');
  const companyInstance = useAppSelector(selectAllCompanies)[0];
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);

  const getCompany = useCallback(() => {
    if (isSignedIn) {
      if (companyInstance) {
        setLoading(false);
      } else {
        dispatch(fetchCompanies())
          .unwrap()
          .finally(() => setLoading(false));
      }
    }
  }, [isSignedIn, companyInstance, dispatch]);

  useEffect(() => {
    getCompany();
  }, [getCompany]);

  if (loading) {
    return (
      <Box
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}
      >
        <CircularProgress color='primary' size={50} />
      </Box>
    );
  }

  if (!companyInstance?.id) {
    return <>{children}</>;
  }

  if (companyInstance && backUrl) {
    return <Navigate to={backUrl} replace />;
  }

  return <Navigate to={ROUTES.INDEX} replace />;
};
